module.exports = __webpack_public_path__ + "media/bg3.6ed2eb09.mp3";